import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {map, Observable} from 'rxjs';
import {Permission} from '../../../enums/permissions.enum';
import {UserService} from '../../services/user.service';
import {
  FOOTER_CONTACT_LINKS,
  FOOTER_COVESTRO_LINKS,
  FOOTER_COVESTRO_TANK_FARM,
  FOOTER_LEGAL_LINKS,
  type FooterLink,
} from './footer-links';

@Component({
  selector: 'cov-footer',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected userService = inject(UserService);

  protected legalLinks = FOOTER_LEGAL_LINKS;
  protected contactLinks = FOOTER_CONTACT_LINKS;

  /**
   * Covestro links include the Tank Farm Assessment link only for users
   * with COVESTRO_CHINA or COVESTRO_EMEA permissions (regional feature).
   */
  protected covestroLinks$: Observable<FooterLink[]> = this.userService
    .hasAnyPermission$([Permission.COVESTRO_CHINA, Permission.COVESTRO_EMEA])
    .pipe(
      map((hasPermission) =>
        hasPermission
          ? [...FOOTER_COVESTRO_LINKS, FOOTER_COVESTRO_TANK_FARM]
          : FOOTER_COVESTRO_LINKS,
      ),
    );

  protected copyrightYear = new Date().getFullYear();
}
